<template>
  <div class="w-full">
    <div
      class="gap-size-8 bg-bg-bg-innerframe p-padding-16 flex w-full flex-col items-center rounded-md p-4"
    >
      <span class="text-font-14">인증번호 전송 이메일 주소</span>
      <span class="text-font-18 font-semibold">{{ userStore.email }}</span>
    </div>
    <div
      class="mt-size-12 border-primary-primary800 bg-primary-primary100 p-size-8 gap-size-4 flex items-start rounded-md border"
    >
      <BaseIcon name="info" size="sm" color="var(--chips-status-pending-text)" />
      <div class="text-font-12 text-[var(--chips-status-pending-text)]">
        <p>인증번호는 6자리 숫자이며, 유효기간은 10분입니다.</p>
        <p>메일이 도착하지 않았다면 스팸함을 확인해주세요.</p>
      </div>
    </div>
  </div>

  <div class="gap-size-8 flex w-full items-center">
    <BaseButton
      size="lg"
      label="인증번호 전송"
      variant="contained"
      color="primary"
      full-width
      @click="handleConfirm"
    />
    <BaseButton
      size="lg"
      label="취소"
      variant="contained"
      color="grey"
      full-width
      @click="handleCancel"
    />
  </div>
</template>
<script setup lang="ts">
import { useUserStore } from '@/stores/useUserStore';
import { BaseIcon, BaseButton } from '@template/ui';
import { authService } from '@/services/api';

const userStore = useUserStore();

const emit = defineEmits(['confirm', 'cancel']);

const handleConfirm = async () => {
  try {
    const res = await authService.sendEmailVerificationCode({
      email: userStore.email,
      useType: 'RESET_PASSWORD',
    });
    if (res.status === 'success') {
      emit('confirm');
    }
  } catch (e) {
    console.error(e);
  }
};

const handleCancel = () => {
  emit('cancel');
};
</script>
